/**
 * Created by Steven-DESK on 10/06/2017.
 */
$(document).ready(function () {
    $(".popup").hide();
    let regexHomeAanm = /\/[Hh]ome\/Aanmelden$/;
    let regexHomeAanmMis = /\/[Hh]ome\/Aanmelden\/Mislukt$/;
    let regexAanmSucc = /\/home\/Success$/;
    let regexUser = /^[a-z]+$/;
    let regexPw = /(?!\s*$).+/;
    if (regexHomeAanm.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Home', '/Home');
        show();
    }
    if (regexAanmSucc.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Home', '/Home');
        $(".aanm_succ").fadeIn(1000).delay(5000).fadeOut(1000);
    }

    if (regexHomeAanmMis.test(window.location.pathname)) {
        window.history.replaceState({}, 'KBSV - Home', '/Home');
        $(".aanm_geg_inc").show();
        show();
    }


    $("#aanmelden").click(function () {
        show();
    });
    $(".aanm_close").click(function () {
        $(".popup").fadeOut(200);
    });
    $(".aanm_ok").click(function () {
        $(".aanm_succ").stop();
    });

    $("#aanm_form").submit(function (e) {
        let pass = true;

        if (!regexUser.test($("#username").val())) {
            pass = false;
            $("#username").addClass("aanm_val_error");
        } else {
            $("#username").removeClass("aanm_val_error");
        }

        if (!regexPw.test($("#password").val())) {
            pass = false;
            $("#password").addClass("aanm_val_error");
        } else {
            $("#password").removeClass("aanm_val_error");
        }

        return pass;
    });

    $("#username").focusout(function () {
        if (!regexUser.test($("#username").val())) {
            pass = false;
            $("#username").addClass("aanm_val_error");
        } else {
            $("#username").removeClass("aanm_val_error");
        }
    });

    $("#password").focusout(function () {
        if (!regexPw.test($("#password").val())) {
            pass = false;
            $("#password").addClass("aanm_val_error");
        } else {
            $("#password").removeClass("aanm_val_error");
        }
    });

    function show() {
        $(".popup").fadeIn(200);
        $(".aanmelden").css({
            top: $(window).height() / 2 - $(".aanmelden").height() / 2,
            left: $(window).width() / 2 - $(".aanmelden").width() / 2
        })
    }

    /* Wachtwoord vergeten */

    $("body").tooltip({selector: '[data-toggle=tooltip]'});


    $("#aanm_forgot").click(function () {
        $(".popup").fadeOut(200);
        showForgot();
    });

    $(".forgot_close").click(function () {
        $(".popupForgot").fadeOut(200);
        $(".popup").fadeIn(200);
    });

    $("#gebruikersnaam").focusout(function () {
        if (regexUser.test($("#gebruikersnaam").val())) {
            $("#gebruikersnaam").removeClass("aanm_val_error");
        } else {
            $("#gebruikersnaam").addClass("aanm_val_error");
        }
    });

    $("#mail").focusout(function () {
        if (regexPw.test($("#mail").val())) {
            $("#mail").removeClass("aanm_val_error");
        } else {
            $("#mail").addClass("aanm_val_error");
        }
    });

    $("#forgot_form").submit(function (e) {
        let pass = true;

        if (!regexUser.test($("#gebruikersnaam").val())) {
            pass = false;
            $("#gebruikersnaam").addClass("aanm_val_error");
        } else {
            $("#gebruikersnaam").removeClass("aanm_val_error");
        }

        if (!regexPw.test($("#mail").val())) {
            pass = false;
            $("#mail").addClass("aanm_val_error");
        } else {
            $("#mail").removeClass("aanm_val_error");
        }

        return pass;
    });


    function showForgot() {
        $(".popupForgot").fadeIn(200);
        $(".wwForgot").css({
            top: $(window).height() / 2 - $(".wwForgot").height() / 2,
            left: $(window).width() / 2 - $(".wwForgot").width() / 2
        })
    }

});


//////////////////
// WEBPACK FOOTER
// ./js/aanmelden.js
// module id = 11
// module chunks = 0